module.exports = __webpack_public_path__ + "img/pro_three_4.e9cdb477.jpg";